export default __webpack_public_path__ + "static/media/SSC_2018_TEDtalks.37166047.pdf";